import React from "react";
import PropTypes from "prop-types";
import { reduxForm } from "redux-form";
import styles from "components/settings/mail-in-settings.scss";
import { FormButton, renderFormElement } from "components/common/form-elements";

const StatelessMailInSettingsForm = ({ onSaveAddress }) => (
  <form className={ styles.form } onSubmit={ (e) => { e.preventDefault(); onSaveAddress(); } }>
    <h2>Update your address:</h2>
    { renderFormElement("First Name", "name", "text") }
    { renderFormElement("Last Name", "surname", "text") }
    { renderFormElement("Address Line 1", "streetLine1", "text") }
    { renderFormElement("Address Line 2", "streetLine2", "text") }
    { renderFormElement("City", "city", "text") }
    { renderFormElement("State", "region", "text") }
    { renderFormElement("Postcode", "postcode", "text") }
    { renderFormElement("Country", "country", "select", countries) }
    <FormButton text={ "Save Changes" } />
  </form>
);

StatelessMailInSettingsForm.propTypes = { onSaveAddress: PropTypes.func.isRequired };

export const MailInSettingsForm = reduxForm({ form: "mailInSettingsForm" })(StatelessMailInSettingsForm);

const countries = [{ key: "AU", name: "AU" }, { key: "NZ", name: "NZ" }];



// WEBPACK FOOTER //
// ./src/js/components/settings/mail-in-settings-form.jsx